import { render, staticRenderFns } from "./Users2.vue?vue&type=template&id=9871d85a&"
import script from "./Users2.vue?vue&type=script&lang=js&"
export * from "./Users2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports